import * as Types from './operations';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const ValidateTokenDocument = gql`
    query ValidateToken {
  validateToken
}
    `;

/**
 * __useValidateTokenQuery__
 *
 * To run a query within a React component, call `useValidateTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateTokenQuery(baseOptions?: Apollo.QueryHookOptions<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>(ValidateTokenDocument, options);
      }
export function useValidateTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>(ValidateTokenDocument, options);
        }
export function useValidateTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>(ValidateTokenDocument, options);
        }
export type ValidateTokenQueryHookResult = ReturnType<typeof useValidateTokenQuery>;
export type ValidateTokenLazyQueryHookResult = ReturnType<typeof useValidateTokenLazyQuery>;
export type ValidateTokenSuspenseQueryHookResult = ReturnType<typeof useValidateTokenSuspenseQuery>;
export type ValidateTokenQueryResult = Apollo.QueryResult<Types.ValidateTokenQuery, Types.ValidateTokenQueryVariables>;
export const PortalLoginDocument = gql`
    mutation PortalLogin($email: String!, $password: String!) {
  portalLogin(password: $password, email: $email) {
    accessToken
    expiresIn
    phoneNumber
    refreshToken
    tokenType
    permissionNames
    storeId
    permissions {
      createdAt
      functions
      id
      name
      role
      updatedAt
    }
  }
}
    `;
export type PortalLoginMutationFn = Apollo.MutationFunction<Types.PortalLoginMutation, Types.PortalLoginMutationVariables>;

/**
 * __usePortalLoginMutation__
 *
 * To run a mutation, you first call `usePortalLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalLoginMutation, { data, loading, error }] = usePortalLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function usePortalLoginMutation(baseOptions?: Apollo.MutationHookOptions<Types.PortalLoginMutation, Types.PortalLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PortalLoginMutation, Types.PortalLoginMutationVariables>(PortalLoginDocument, options);
      }
export type PortalLoginMutationHookResult = ReturnType<typeof usePortalLoginMutation>;
export type PortalLoginMutationResult = Apollo.MutationResult<Types.PortalLoginMutation>;
export type PortalLoginMutationOptions = Apollo.BaseMutationOptions<Types.PortalLoginMutation, Types.PortalLoginMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    accessToken
    expiresIn
    refreshToken
    tokenType
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<Types.RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout($refreshToken: String!) {
  logout(refreshToken: $refreshToken)
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<Types.LogoutMutation, Types.LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<Types.LogoutMutation, Types.LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LogoutMutation, Types.LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<Types.LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<Types.LogoutMutation, Types.LogoutMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<Types.ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($newPassword: String!, $token: String!) {
  resetPassword(newPassword: $newPassword, token: $token)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<Types.ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>;
export const GetPartnerBalanceDocument = gql`
    query GetPartnerBalance($filter: GetBalanceFilterDto) {
  getPartnerBalance(filter: $filter) {
    totalBalance
    storeBalances {
      balance
      storeId
      storeName
      storeNameAr
    }
  }
}
    `;

/**
 * __useGetPartnerBalanceQuery__
 *
 * To run a query within a React component, call `useGetPartnerBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerBalanceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPartnerBalanceQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetPartnerBalanceQuery, Types.GetPartnerBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPartnerBalanceQuery, Types.GetPartnerBalanceQueryVariables>(GetPartnerBalanceDocument, options);
      }
export function useGetPartnerBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPartnerBalanceQuery, Types.GetPartnerBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPartnerBalanceQuery, Types.GetPartnerBalanceQueryVariables>(GetPartnerBalanceDocument, options);
        }
export function useGetPartnerBalanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPartnerBalanceQuery, Types.GetPartnerBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPartnerBalanceQuery, Types.GetPartnerBalanceQueryVariables>(GetPartnerBalanceDocument, options);
        }
export type GetPartnerBalanceQueryHookResult = ReturnType<typeof useGetPartnerBalanceQuery>;
export type GetPartnerBalanceLazyQueryHookResult = ReturnType<typeof useGetPartnerBalanceLazyQuery>;
export type GetPartnerBalanceSuspenseQueryHookResult = ReturnType<typeof useGetPartnerBalanceSuspenseQuery>;
export type GetPartnerBalanceQueryResult = Apollo.QueryResult<Types.GetPartnerBalanceQuery, Types.GetPartnerBalanceQueryVariables>;
export const GetMyPendingInvitationsDocument = gql`
    query GetMyPendingInvitations {
  getPendingInvitationsForPartner {
    email
    partnerId
    storeId
    storeName
    token
    acceptedAt
  }
}
    `;

/**
 * __useGetMyPendingInvitationsQuery__
 *
 * To run a query within a React component, call `useGetMyPendingInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPendingInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPendingInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPendingInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMyPendingInvitationsQuery, Types.GetMyPendingInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMyPendingInvitationsQuery, Types.GetMyPendingInvitationsQueryVariables>(GetMyPendingInvitationsDocument, options);
      }
export function useGetMyPendingInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMyPendingInvitationsQuery, Types.GetMyPendingInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMyPendingInvitationsQuery, Types.GetMyPendingInvitationsQueryVariables>(GetMyPendingInvitationsDocument, options);
        }
export function useGetMyPendingInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMyPendingInvitationsQuery, Types.GetMyPendingInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMyPendingInvitationsQuery, Types.GetMyPendingInvitationsQueryVariables>(GetMyPendingInvitationsDocument, options);
        }
export type GetMyPendingInvitationsQueryHookResult = ReturnType<typeof useGetMyPendingInvitationsQuery>;
export type GetMyPendingInvitationsLazyQueryHookResult = ReturnType<typeof useGetMyPendingInvitationsLazyQuery>;
export type GetMyPendingInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetMyPendingInvitationsSuspenseQuery>;
export type GetMyPendingInvitationsQueryResult = Apollo.QueryResult<Types.GetMyPendingInvitationsQuery, Types.GetMyPendingInvitationsQueryVariables>;
export const InviteUserForPartnerDocument = gql`
    mutation InviteUserForPartner($email: String!, $storeId: Int) {
  inviteUserForPartner(
    createPartnerInvitationDto: {email: $email, storeId: $storeId}
  )
}
    `;
export type InviteUserForPartnerMutationFn = Apollo.MutationFunction<Types.InviteUserForPartnerMutation, Types.InviteUserForPartnerMutationVariables>;

/**
 * __useInviteUserForPartnerMutation__
 *
 * To run a mutation, you first call `useInviteUserForPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserForPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserForPartnerMutation, { data, loading, error }] = useInviteUserForPartnerMutation({
 *   variables: {
 *      email: // value for 'email'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useInviteUserForPartnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.InviteUserForPartnerMutation, Types.InviteUserForPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InviteUserForPartnerMutation, Types.InviteUserForPartnerMutationVariables>(InviteUserForPartnerDocument, options);
      }
export type InviteUserForPartnerMutationHookResult = ReturnType<typeof useInviteUserForPartnerMutation>;
export type InviteUserForPartnerMutationResult = Apollo.MutationResult<Types.InviteUserForPartnerMutation>;
export type InviteUserForPartnerMutationOptions = Apollo.BaseMutationOptions<Types.InviteUserForPartnerMutation, Types.InviteUserForPartnerMutationVariables>;
export const ValidateInvitationDocument = gql`
    mutation validateInvitation($token: String!) {
  validateInvitation(token: $token)
}
    `;
export type ValidateInvitationMutationFn = Apollo.MutationFunction<Types.ValidateInvitationMutation, Types.ValidateInvitationMutationVariables>;

/**
 * __useValidateInvitationMutation__
 *
 * To run a mutation, you first call `useValidateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateInvitationMutation, { data, loading, error }] = useValidateInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateInvitationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ValidateInvitationMutation, Types.ValidateInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ValidateInvitationMutation, Types.ValidateInvitationMutationVariables>(ValidateInvitationDocument, options);
      }
export type ValidateInvitationMutationHookResult = ReturnType<typeof useValidateInvitationMutation>;
export type ValidateInvitationMutationResult = Apollo.MutationResult<Types.ValidateInvitationMutation>;
export type ValidateInvitationMutationOptions = Apollo.BaseMutationOptions<Types.ValidateInvitationMutation, Types.ValidateInvitationMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation acceptInvitation($token: String!, $password: String!) {
  acceptInvitation(token: $token, password: $password) {
    success
    storeId
  }
}
    `;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<Types.AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>;
export const LedgerTransactionsDocument = gql`
    query LedgerTransactions($pagination: PaginationInput!, $filter: LedgerTransactionsFilter, $sort: SortInput) {
  ledgerTransactions(pagination: $pagination, filter: $filter, sort: $sort) {
    hasMore
    total
    items {
      amountMinor
      availableAt
      correlationId
      createdAt
      description
      id
      idempotencyKey
      orderId
      postedAt
      storeId
      type
      partner {
        ar
        en
      }
      store {
        ar
        en
      }
    }
  }
}
    `;

/**
 * __useLedgerTransactionsQuery__
 *
 * To run a query within a React component, call `useLedgerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerTransactionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLedgerTransactionsQuery(baseOptions: Apollo.QueryHookOptions<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables> & ({ variables: Types.LedgerTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>(LedgerTransactionsDocument, options);
      }
export function useLedgerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>(LedgerTransactionsDocument, options);
        }
export function useLedgerTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>(LedgerTransactionsDocument, options);
        }
export type LedgerTransactionsQueryHookResult = ReturnType<typeof useLedgerTransactionsQuery>;
export type LedgerTransactionsLazyQueryHookResult = ReturnType<typeof useLedgerTransactionsLazyQuery>;
export type LedgerTransactionsSuspenseQueryHookResult = ReturnType<typeof useLedgerTransactionsSuspenseQuery>;
export type LedgerTransactionsQueryResult = Apollo.QueryResult<Types.LedgerTransactionsQuery, Types.LedgerTransactionsQueryVariables>;
export const DownloadLedgerTransactionsDocument = gql`
    query DownloadLedgerTransactions($filter: LedgerTransactionsFilter) {
  downloadLedgerTransactions(filter: $filter) {
    fileContent
    filename
    mimeType
  }
}
    `;

/**
 * __useDownloadLedgerTransactionsQuery__
 *
 * To run a query within a React component, call `useDownloadLedgerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadLedgerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadLedgerTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDownloadLedgerTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>(DownloadLedgerTransactionsDocument, options);
      }
export function useDownloadLedgerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>(DownloadLedgerTransactionsDocument, options);
        }
export function useDownloadLedgerTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>(DownloadLedgerTransactionsDocument, options);
        }
export type DownloadLedgerTransactionsQueryHookResult = ReturnType<typeof useDownloadLedgerTransactionsQuery>;
export type DownloadLedgerTransactionsLazyQueryHookResult = ReturnType<typeof useDownloadLedgerTransactionsLazyQuery>;
export type DownloadLedgerTransactionsSuspenseQueryHookResult = ReturnType<typeof useDownloadLedgerTransactionsSuspenseQuery>;
export type DownloadLedgerTransactionsQueryResult = Apollo.QueryResult<Types.DownloadLedgerTransactionsQuery, Types.DownloadLedgerTransactionsQueryVariables>;
export const RegionsLookupDocument = gql`
    query RegionsLookup {
  regionsLookup {
    errorCodes
    status
    data {
      id
      nameAr
      nameEn
    }
  }
}
    `;

/**
 * __useRegionsLookupQuery__
 *
 * To run a query within a React component, call `useRegionsLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsLookupQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionsLookupQuery(baseOptions?: Apollo.QueryHookOptions<Types.RegionsLookupQuery, Types.RegionsLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RegionsLookupQuery, Types.RegionsLookupQueryVariables>(RegionsLookupDocument, options);
      }
export function useRegionsLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RegionsLookupQuery, Types.RegionsLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RegionsLookupQuery, Types.RegionsLookupQueryVariables>(RegionsLookupDocument, options);
        }
export function useRegionsLookupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RegionsLookupQuery, Types.RegionsLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RegionsLookupQuery, Types.RegionsLookupQueryVariables>(RegionsLookupDocument, options);
        }
export type RegionsLookupQueryHookResult = ReturnType<typeof useRegionsLookupQuery>;
export type RegionsLookupLazyQueryHookResult = ReturnType<typeof useRegionsLookupLazyQuery>;
export type RegionsLookupSuspenseQueryHookResult = ReturnType<typeof useRegionsLookupSuspenseQuery>;
export type RegionsLookupQueryResult = Apollo.QueryResult<Types.RegionsLookupQuery, Types.RegionsLookupQueryVariables>;
export const CitiesLookupDocument = gql`
    query CitiesLookup($regionId: String!) {
  citiesLookup(regionId: $regionId) {
    errorCodes
    status
    data {
      id
      nameAr
      nameEn
    }
  }
}
    `;

/**
 * __useCitiesLookupQuery__
 *
 * To run a query within a React component, call `useCitiesLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitiesLookupQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCitiesLookupQuery(baseOptions: Apollo.QueryHookOptions<Types.CitiesLookupQuery, Types.CitiesLookupQueryVariables> & ({ variables: Types.CitiesLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CitiesLookupQuery, Types.CitiesLookupQueryVariables>(CitiesLookupDocument, options);
      }
export function useCitiesLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CitiesLookupQuery, Types.CitiesLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CitiesLookupQuery, Types.CitiesLookupQueryVariables>(CitiesLookupDocument, options);
        }
export function useCitiesLookupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CitiesLookupQuery, Types.CitiesLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CitiesLookupQuery, Types.CitiesLookupQueryVariables>(CitiesLookupDocument, options);
        }
export type CitiesLookupQueryHookResult = ReturnType<typeof useCitiesLookupQuery>;
export type CitiesLookupLazyQueryHookResult = ReturnType<typeof useCitiesLookupLazyQuery>;
export type CitiesLookupSuspenseQueryHookResult = ReturnType<typeof useCitiesLookupSuspenseQuery>;
export type CitiesLookupQueryResult = Apollo.QueryResult<Types.CitiesLookupQuery, Types.CitiesLookupQueryVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($base64File: String!, $originalName: String!, $altText: String, $description: String, $tags: [String!], $folder: String) {
  uploadFile(
    base64File: $base64File
    originalName: $originalName
    altText: $altText
    description: $description
    tags: $tags
    folder: $folder
  ) {
    id
    url
    fileName
    originalName
    mimeType
    size
    altText
    description
    tags
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<Types.UploadFileMutation, Types.UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      base64File: // value for 'base64File'
 *      originalName: // value for 'originalName'
 *      altText: // value for 'altText'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadFileMutation, Types.UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadFileMutation, Types.UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<Types.UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<Types.UploadFileMutation, Types.UploadFileMutationVariables>;
export const GetMediaByIdDocument = gql`
    query GetMediaById($id: Int!) {
  getMediaById(id: $id) {
    id
    url
    fileName
    originalName
    mimeType
    size
    altText
    description
    tags
  }
}
    `;

/**
 * __useGetMediaByIdQuery__
 *
 * To run a query within a React component, call `useGetMediaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMediaByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables> & ({ variables: Types.GetMediaByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>(GetMediaByIdDocument, options);
      }
export function useGetMediaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>(GetMediaByIdDocument, options);
        }
export function useGetMediaByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>(GetMediaByIdDocument, options);
        }
export type GetMediaByIdQueryHookResult = ReturnType<typeof useGetMediaByIdQuery>;
export type GetMediaByIdLazyQueryHookResult = ReturnType<typeof useGetMediaByIdLazyQuery>;
export type GetMediaByIdSuspenseQueryHookResult = ReturnType<typeof useGetMediaByIdSuspenseQuery>;
export type GetMediaByIdQueryResult = Apollo.QueryResult<Types.GetMediaByIdQuery, Types.GetMediaByIdQueryVariables>;
export const DeleteMediaDocument = gql`
    mutation DeleteMedia($id: Int!) {
  deleteMedia(id: $id)
}
    `;
export type DeleteMediaMutationFn = Apollo.MutationFunction<Types.DeleteMediaMutation, Types.DeleteMediaMutationVariables>;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaMutation, { data, loading, error }] = useDeleteMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteMediaMutation, Types.DeleteMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteMediaMutation, Types.DeleteMediaMutationVariables>(DeleteMediaDocument, options);
      }
export type DeleteMediaMutationHookResult = ReturnType<typeof useDeleteMediaMutation>;
export type DeleteMediaMutationResult = Apollo.MutationResult<Types.DeleteMediaMutation>;
export type DeleteMediaMutationOptions = Apollo.BaseMutationOptions<Types.DeleteMediaMutation, Types.DeleteMediaMutationVariables>;
export const OrderCreatedDocument = gql`
    subscription OrderCreated($storeId: Int!) {
  orderCreated(storeId: $storeId) {
    id
    userPhoneNumber
  }
}
    `;

/**
 * __useOrderCreatedSubscription__
 *
 * To run a query within a React component, call `useOrderCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderCreatedSubscription({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useOrderCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.OrderCreatedSubscription, Types.OrderCreatedSubscriptionVariables> & ({ variables: Types.OrderCreatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.OrderCreatedSubscription, Types.OrderCreatedSubscriptionVariables>(OrderCreatedDocument, options);
      }
export type OrderCreatedSubscriptionHookResult = ReturnType<typeof useOrderCreatedSubscription>;
export type OrderCreatedSubscriptionResult = Apollo.SubscriptionResult<Types.OrderCreatedSubscription>;
export const OrderUpdatedDocument = gql`
    subscription OrderUpdated($storeId: Int!) {
  orderUpdated(storeId: $storeId) {
    id
    status
    userPhoneNumber
  }
}
    `;

/**
 * __useOrderUpdatedSubscription__
 *
 * To run a query within a React component, call `useOrderUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderUpdatedSubscription({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useOrderUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<Types.OrderUpdatedSubscription, Types.OrderUpdatedSubscriptionVariables> & ({ variables: Types.OrderUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.OrderUpdatedSubscription, Types.OrderUpdatedSubscriptionVariables>(OrderUpdatedDocument, options);
      }
export type OrderUpdatedSubscriptionHookResult = ReturnType<typeof useOrderUpdatedSubscription>;
export type OrderUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.OrderUpdatedSubscription>;
export const GetOrderForPartnerDocument = gql`
    query getOrderForPartner($id: Int!) {
  getOrderForPartner(id: $id) {
    distance
    restaurantRevenue
    order {
      additionalCustomerFee
      addressCoordinates
      createdAt
      deliveryFee
      deliveryInstructions
      deliveryPosition
      discountAmount
      discountPartnerCoverageAmount
      duePaymentAmount
      id
      parentId
      partnerDeliveryCoverageAmount
      platformCommission
      scheduledAt
      status
      storeAddressCoordinates
      storeName
      storeNameAr
      subtotalAmount
      tip
      totalAmount
      updatedAt
      userPhoneNumber
      items {
        id
        optionLabels
        optionLabelsAr
        optionPrices
        productName
        productNameAr
        productPrice
        quantity
      }
      payment {
        id
        amount
        status
        source
        flowType
      }
    }
    transactions {
      amountMinor
      description
      type
    }
  }
}
    `;

/**
 * __useGetOrderForPartnerQuery__
 *
 * To run a query within a React component, call `useGetOrderForPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderForPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderForPartnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderForPartnerQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrderForPartnerQuery, Types.GetOrderForPartnerQueryVariables> & ({ variables: Types.GetOrderForPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrderForPartnerQuery, Types.GetOrderForPartnerQueryVariables>(GetOrderForPartnerDocument, options);
      }
export function useGetOrderForPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrderForPartnerQuery, Types.GetOrderForPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrderForPartnerQuery, Types.GetOrderForPartnerQueryVariables>(GetOrderForPartnerDocument, options);
        }
export function useGetOrderForPartnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrderForPartnerQuery, Types.GetOrderForPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrderForPartnerQuery, Types.GetOrderForPartnerQueryVariables>(GetOrderForPartnerDocument, options);
        }
export type GetOrderForPartnerQueryHookResult = ReturnType<typeof useGetOrderForPartnerQuery>;
export type GetOrderForPartnerLazyQueryHookResult = ReturnType<typeof useGetOrderForPartnerLazyQuery>;
export type GetOrderForPartnerSuspenseQueryHookResult = ReturnType<typeof useGetOrderForPartnerSuspenseQuery>;
export type GetOrderForPartnerQueryResult = Apollo.QueryResult<Types.GetOrderForPartnerQuery, Types.GetOrderForPartnerQueryVariables>;
export const GetAllOrdersForPartnerDocument = gql`
    query GetAllOrdersForPartner($searchOrderDto: SearchOrderDto!) {
  getAllOrdersForPartner(searchOrderDto: $searchOrderDto) {
    createdAt
    id
    status
    subtotalAmount
    totalAmount
    userPhoneNumber
    discountAmount
    deliveryFee
    items {
      id
      optionLabels
      optionLabelsAr
      optionPrices
      productName
      productNameAr
      productPrice
      quantity
    }
    storeName
    storeNameAr
    payment {
      id
      amount
      status
      source
      flowType
    }
  }
}
    `;

/**
 * __useGetAllOrdersForPartnerQuery__
 *
 * To run a query within a React component, call `useGetAllOrdersForPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrdersForPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrdersForPartnerQuery({
 *   variables: {
 *      searchOrderDto: // value for 'searchOrderDto'
 *   },
 * });
 */
export function useGetAllOrdersForPartnerQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAllOrdersForPartnerQuery, Types.GetAllOrdersForPartnerQueryVariables> & ({ variables: Types.GetAllOrdersForPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllOrdersForPartnerQuery, Types.GetAllOrdersForPartnerQueryVariables>(GetAllOrdersForPartnerDocument, options);
      }
export function useGetAllOrdersForPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllOrdersForPartnerQuery, Types.GetAllOrdersForPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllOrdersForPartnerQuery, Types.GetAllOrdersForPartnerQueryVariables>(GetAllOrdersForPartnerDocument, options);
        }
export function useGetAllOrdersForPartnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllOrdersForPartnerQuery, Types.GetAllOrdersForPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllOrdersForPartnerQuery, Types.GetAllOrdersForPartnerQueryVariables>(GetAllOrdersForPartnerDocument, options);
        }
export type GetAllOrdersForPartnerQueryHookResult = ReturnType<typeof useGetAllOrdersForPartnerQuery>;
export type GetAllOrdersForPartnerLazyQueryHookResult = ReturnType<typeof useGetAllOrdersForPartnerLazyQuery>;
export type GetAllOrdersForPartnerSuspenseQueryHookResult = ReturnType<typeof useGetAllOrdersForPartnerSuspenseQuery>;
export type GetAllOrdersForPartnerQueryResult = Apollo.QueryResult<Types.GetAllOrdersForPartnerQuery, Types.GetAllOrdersForPartnerQueryVariables>;
export const ConfirmOrderDocument = gql`
    mutation confirmOrder($orderId: Int!) {
  confirmOrder(orderId: $orderId) {
    id
  }
}
    `;
export type ConfirmOrderMutationFn = Apollo.MutationFunction<Types.ConfirmOrderMutation, Types.ConfirmOrderMutationVariables>;

/**
 * __useConfirmOrderMutation__
 *
 * To run a mutation, you first call `useConfirmOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrderMutation, { data, loading, error }] = useConfirmOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useConfirmOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConfirmOrderMutation, Types.ConfirmOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConfirmOrderMutation, Types.ConfirmOrderMutationVariables>(ConfirmOrderDocument, options);
      }
export type ConfirmOrderMutationHookResult = ReturnType<typeof useConfirmOrderMutation>;
export type ConfirmOrderMutationResult = Apollo.MutationResult<Types.ConfirmOrderMutation>;
export type ConfirmOrderMutationOptions = Apollo.BaseMutationOptions<Types.ConfirmOrderMutation, Types.ConfirmOrderMutationVariables>;
export const StartPreparingOrderDocument = gql`
    mutation startPreparingOrder($orderId: Int!) {
  startPreparingOrder(orderId: $orderId) {
    id
  }
}
    `;
export type StartPreparingOrderMutationFn = Apollo.MutationFunction<Types.StartPreparingOrderMutation, Types.StartPreparingOrderMutationVariables>;

/**
 * __useStartPreparingOrderMutation__
 *
 * To run a mutation, you first call `useStartPreparingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPreparingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPreparingOrderMutation, { data, loading, error }] = useStartPreparingOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useStartPreparingOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.StartPreparingOrderMutation, Types.StartPreparingOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.StartPreparingOrderMutation, Types.StartPreparingOrderMutationVariables>(StartPreparingOrderDocument, options);
      }
export type StartPreparingOrderMutationHookResult = ReturnType<typeof useStartPreparingOrderMutation>;
export type StartPreparingOrderMutationResult = Apollo.MutationResult<Types.StartPreparingOrderMutation>;
export type StartPreparingOrderMutationOptions = Apollo.BaseMutationOptions<Types.StartPreparingOrderMutation, Types.StartPreparingOrderMutationVariables>;
export const MarkOrderReadyForPickupDocument = gql`
    mutation markOrderReadyForPickup($orderId: Int!) {
  markOrderReadyForPickup(orderId: $orderId) {
    id
  }
}
    `;
export type MarkOrderReadyForPickupMutationFn = Apollo.MutationFunction<Types.MarkOrderReadyForPickupMutation, Types.MarkOrderReadyForPickupMutationVariables>;

/**
 * __useMarkOrderReadyForPickupMutation__
 *
 * To run a mutation, you first call `useMarkOrderReadyForPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOrderReadyForPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOrderReadyForPickupMutation, { data, loading, error }] = useMarkOrderReadyForPickupMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useMarkOrderReadyForPickupMutation(baseOptions?: Apollo.MutationHookOptions<Types.MarkOrderReadyForPickupMutation, Types.MarkOrderReadyForPickupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MarkOrderReadyForPickupMutation, Types.MarkOrderReadyForPickupMutationVariables>(MarkOrderReadyForPickupDocument, options);
      }
export type MarkOrderReadyForPickupMutationHookResult = ReturnType<typeof useMarkOrderReadyForPickupMutation>;
export type MarkOrderReadyForPickupMutationResult = Apollo.MutationResult<Types.MarkOrderReadyForPickupMutation>;
export type MarkOrderReadyForPickupMutationOptions = Apollo.BaseMutationOptions<Types.MarkOrderReadyForPickupMutation, Types.MarkOrderReadyForPickupMutationVariables>;
export const ChangeOrderStatusDocument = gql`
    mutation ChangeOrderStatus($orderId: Int!) {
  changeOrderStatus(orderId: $orderId) {
    id
    status
  }
}
    `;
export type ChangeOrderStatusMutationFn = Apollo.MutationFunction<Types.ChangeOrderStatusMutation, Types.ChangeOrderStatusMutationVariables>;

/**
 * __useChangeOrderStatusMutation__
 *
 * To run a mutation, you first call `useChangeOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrderStatusMutation, { data, loading, error }] = useChangeOrderStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useChangeOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChangeOrderStatusMutation, Types.ChangeOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChangeOrderStatusMutation, Types.ChangeOrderStatusMutationVariables>(ChangeOrderStatusDocument, options);
      }
export type ChangeOrderStatusMutationHookResult = ReturnType<typeof useChangeOrderStatusMutation>;
export type ChangeOrderStatusMutationResult = Apollo.MutationResult<Types.ChangeOrderStatusMutation>;
export type ChangeOrderStatusMutationOptions = Apollo.BaseMutationOptions<Types.ChangeOrderStatusMutation, Types.ChangeOrderStatusMutationVariables>;
export const CancelOrderDocument = gql`
    mutation cancelOrder($orderId: Int!) {
  cancelOrder(orderId: $orderId) {
    id
    status
  }
}
    `;
export type CancelOrderMutationFn = Apollo.MutationFunction<Types.CancelOrderMutation, Types.CancelOrderMutationVariables>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCancelOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.CancelOrderMutation, Types.CancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CancelOrderMutation, Types.CancelOrderMutationVariables>(CancelOrderDocument, options);
      }
export type CancelOrderMutationHookResult = ReturnType<typeof useCancelOrderMutation>;
export type CancelOrderMutationResult = Apollo.MutationResult<Types.CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<Types.CancelOrderMutation, Types.CancelOrderMutationVariables>;
export const GetMyPartnerDocument = gql`
    query getMyPartner {
  getPartner(id: null) {
    address
    createdAt
    email
    id
    name
    nameAr
    phone
    updatedAt
    image {
      id
      url
    }
    coverImage {
      id
      url
    }
    productImage {
      id
      url
    }
    partnerCategories {
      id
      name
    }
  }
}
    `;

/**
 * __useGetMyPartnerQuery__
 *
 * To run a query within a React component, call `useGetMyPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPartnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPartnerQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMyPartnerQuery, Types.GetMyPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMyPartnerQuery, Types.GetMyPartnerQueryVariables>(GetMyPartnerDocument, options);
      }
export function useGetMyPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMyPartnerQuery, Types.GetMyPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMyPartnerQuery, Types.GetMyPartnerQueryVariables>(GetMyPartnerDocument, options);
        }
export function useGetMyPartnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMyPartnerQuery, Types.GetMyPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMyPartnerQuery, Types.GetMyPartnerQueryVariables>(GetMyPartnerDocument, options);
        }
export type GetMyPartnerQueryHookResult = ReturnType<typeof useGetMyPartnerQuery>;
export type GetMyPartnerLazyQueryHookResult = ReturnType<typeof useGetMyPartnerLazyQuery>;
export type GetMyPartnerSuspenseQueryHookResult = ReturnType<typeof useGetMyPartnerSuspenseQuery>;
export type GetMyPartnerQueryResult = Apollo.QueryResult<Types.GetMyPartnerQuery, Types.GetMyPartnerQueryVariables>;
export const UpdateMyPartnerDocument = gql`
    mutation updateMyPartner($address: String, $email: String, $phone: String, $imageId: Int, $coverImageId: Int, $productImageId: Int, $name: String, $nameAr: String, $partnerCategoryIds: [Int!]) {
  updatePartner(
    id: null
    updatePartnerDto: {address: $address, email: $email, phone: $phone, imageId: $imageId, coverImageId: $coverImageId, productImageId: $productImageId, name: $name, nameAr: $nameAr, partnerCategoryIds: $partnerCategoryIds}
  ) {
    id
  }
}
    `;
export type UpdateMyPartnerMutationFn = Apollo.MutationFunction<Types.UpdateMyPartnerMutation, Types.UpdateMyPartnerMutationVariables>;

/**
 * __useUpdateMyPartnerMutation__
 *
 * To run a mutation, you first call `useUpdateMyPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyPartnerMutation, { data, loading, error }] = useUpdateMyPartnerMutation({
 *   variables: {
 *      address: // value for 'address'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      imageId: // value for 'imageId'
 *      coverImageId: // value for 'coverImageId'
 *      productImageId: // value for 'productImageId'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      partnerCategoryIds: // value for 'partnerCategoryIds'
 *   },
 * });
 */
export function useUpdateMyPartnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMyPartnerMutation, Types.UpdateMyPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMyPartnerMutation, Types.UpdateMyPartnerMutationVariables>(UpdateMyPartnerDocument, options);
      }
export type UpdateMyPartnerMutationHookResult = ReturnType<typeof useUpdateMyPartnerMutation>;
export type UpdateMyPartnerMutationResult = Apollo.MutationResult<Types.UpdateMyPartnerMutation>;
export type UpdateMyPartnerMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMyPartnerMutation, Types.UpdateMyPartnerMutationVariables>;
export const GetAllPartnerCategoriesDocument = gql`
    query GetAllPartnerCategories {
  getAllPartnerCategories {
    id
    name
  }
}
    `;

/**
 * __useGetAllPartnerCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllPartnerCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPartnerCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPartnerCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPartnerCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>(GetAllPartnerCategoriesDocument, options);
      }
export function useGetAllPartnerCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>(GetAllPartnerCategoriesDocument, options);
        }
export function useGetAllPartnerCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>(GetAllPartnerCategoriesDocument, options);
        }
export type GetAllPartnerCategoriesQueryHookResult = ReturnType<typeof useGetAllPartnerCategoriesQuery>;
export type GetAllPartnerCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllPartnerCategoriesLazyQuery>;
export type GetAllPartnerCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetAllPartnerCategoriesSuspenseQuery>;
export type GetAllPartnerCategoriesQueryResult = Apollo.QueryResult<Types.GetAllPartnerCategoriesQuery, Types.GetAllPartnerCategoriesQueryVariables>;
export const GetAllMyProductsDocument = gql`
    query getAllMyProducts {
  getAllProductsForPartner {
    createdAt
    description
    descriptionAr
    foodQualityTimeMinutes
    id
    name
    nameAr
    price
    updatedAt
    productStores {
      id
      outOfStock
      storeId
      productId
    }
    stores {
      id
      name
    }
    productCategory {
      name
      id
    }
    productOptionCategories {
      name
      id
    }
    image {
      id
      url
    }
  }
}
    `;

/**
 * __useGetAllMyProductsQuery__
 *
 * To run a query within a React component, call `useGetAllMyProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMyProductsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllMyProductsQuery, Types.GetAllMyProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllMyProductsQuery, Types.GetAllMyProductsQueryVariables>(GetAllMyProductsDocument, options);
      }
export function useGetAllMyProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllMyProductsQuery, Types.GetAllMyProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllMyProductsQuery, Types.GetAllMyProductsQueryVariables>(GetAllMyProductsDocument, options);
        }
export function useGetAllMyProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllMyProductsQuery, Types.GetAllMyProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllMyProductsQuery, Types.GetAllMyProductsQueryVariables>(GetAllMyProductsDocument, options);
        }
export type GetAllMyProductsQueryHookResult = ReturnType<typeof useGetAllMyProductsQuery>;
export type GetAllMyProductsLazyQueryHookResult = ReturnType<typeof useGetAllMyProductsLazyQuery>;
export type GetAllMyProductsSuspenseQueryHookResult = ReturnType<typeof useGetAllMyProductsSuspenseQuery>;
export type GetAllMyProductsQueryResult = Apollo.QueryResult<Types.GetAllMyProductsQuery, Types.GetAllMyProductsQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($id: Int!) {
  getProduct(id: $id) {
    createdAt
    description
    descriptionAr
    foodQualityTimeMinutes
    id
    name
    nameAr
    price
    updatedAt
    stores {
      id
      name
    }
    productCategory {
      id
      name
    }
    productOptionCategories {
      id
      name
    }
    image {
      id
      url
    }
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<Types.GetProductQuery, Types.GetProductQueryVariables> & ({ variables: Types.GetProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProductQuery, Types.GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProductQuery, Types.GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProductQuery, Types.GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetProductQuery, Types.GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetProductQuery, Types.GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<Types.GetProductQuery, Types.GetProductQueryVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($storeIds: [Int!]!, $name: String!, $nameAr: String!, $description: String, $descriptionAr: String, $foodQualityTimeMinutes: Int, $price: Float!, $productCategoryId: Int!, $productOptionCategoryIds: [Int!], $imageId: Int) {
  createProduct(
    createProductDto: {storeIds: $storeIds, name: $name, nameAr: $nameAr, description: $description, descriptionAr: $descriptionAr, foodQualityTimeMinutes: $foodQualityTimeMinutes, price: $price, productCategoryId: $productCategoryId, productOptionCategoryIds: $productOptionCategoryIds, imageId: $imageId}
  ) {
    id
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<Types.CreateProductMutation, Types.CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      storeIds: // value for 'storeIds'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      description: // value for 'description'
 *      descriptionAr: // value for 'descriptionAr'
 *      foodQualityTimeMinutes: // value for 'foodQualityTimeMinutes'
 *      price: // value for 'price'
 *      productCategoryId: // value for 'productCategoryId'
 *      productOptionCategoryIds: // value for 'productOptionCategoryIds'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductMutation, Types.CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductMutation, Types.CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<Types.CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductMutation, Types.CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($id: Int!, $storeIds: [Int!]!, $name: String!, $nameAr: String!, $description: String, $descriptionAr: String, $foodQualityTimeMinutes: Int, $price: Float!, $productCategoryId: Int!, $productOptionCategoryIds: [Int!], $imageId: Int) {
  updateProduct(
    id: $id
    updateProductDto: {storeIds: $storeIds, name: $name, nameAr: $nameAr, description: $description, descriptionAr: $descriptionAr, foodQualityTimeMinutes: $foodQualityTimeMinutes, price: $price, productCategoryId: $productCategoryId, productOptionCategoryIds: $productOptionCategoryIds, imageId: $imageId}
  ) {
    id
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<Types.UpdateProductMutation, Types.UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      storeIds: // value for 'storeIds'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      description: // value for 'description'
 *      descriptionAr: // value for 'descriptionAr'
 *      foodQualityTimeMinutes: // value for 'foodQualityTimeMinutes'
 *      price: // value for 'price'
 *      productCategoryId: // value for 'productCategoryId'
 *      productOptionCategoryIds: // value for 'productOptionCategoryIds'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductMutation, Types.UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductMutation, Types.UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<Types.UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductMutation, Types.UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($id: Int!) {
  deleteProduct(id: $id)
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<Types.DeleteProductMutation, Types.DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductMutation, Types.DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductMutation, Types.DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<Types.DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductMutation, Types.DeleteProductMutationVariables>;
export const ActivateProductsDocument = gql`
    mutation activateProducts($ids: [Int!]!) {
  activateProducts(ids: $ids)
}
    `;
export type ActivateProductsMutationFn = Apollo.MutationFunction<Types.ActivateProductsMutation, Types.ActivateProductsMutationVariables>;

/**
 * __useActivateProductsMutation__
 *
 * To run a mutation, you first call `useActivateProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateProductsMutation, { data, loading, error }] = useActivateProductsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useActivateProductsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ActivateProductsMutation, Types.ActivateProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ActivateProductsMutation, Types.ActivateProductsMutationVariables>(ActivateProductsDocument, options);
      }
export type ActivateProductsMutationHookResult = ReturnType<typeof useActivateProductsMutation>;
export type ActivateProductsMutationResult = Apollo.MutationResult<Types.ActivateProductsMutation>;
export type ActivateProductsMutationOptions = Apollo.BaseMutationOptions<Types.ActivateProductsMutation, Types.ActivateProductsMutationVariables>;
export const DeactivateProductsDocument = gql`
    mutation deactivateProducts($ids: [Int!]!) {
  deactivateProducts(ids: $ids)
}
    `;
export type DeactivateProductsMutationFn = Apollo.MutationFunction<Types.DeactivateProductsMutation, Types.DeactivateProductsMutationVariables>;

/**
 * __useDeactivateProductsMutation__
 *
 * To run a mutation, you first call `useDeactivateProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateProductsMutation, { data, loading, error }] = useDeactivateProductsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeactivateProductsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeactivateProductsMutation, Types.DeactivateProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeactivateProductsMutation, Types.DeactivateProductsMutationVariables>(DeactivateProductsDocument, options);
      }
export type DeactivateProductsMutationHookResult = ReturnType<typeof useDeactivateProductsMutation>;
export type DeactivateProductsMutationResult = Apollo.MutationResult<Types.DeactivateProductsMutation>;
export type DeactivateProductsMutationOptions = Apollo.BaseMutationOptions<Types.DeactivateProductsMutation, Types.DeactivateProductsMutationVariables>;
export const SetStoreProductOutOfStockDocument = gql`
    mutation SetStoreProductOutOfStock($id: Int!, $outOfStock: Boolean!, $storeIds: [Int!]!) {
  setStoreProductOutOfStock(
    id: $id
    input: {outOfStock: $outOfStock, storeIds: $storeIds}
  ) {
    createdAt
    description
    descriptionAr
    id
    isActive
    name
    nameAr
    price
    updatedAt
  }
}
    `;
export type SetStoreProductOutOfStockMutationFn = Apollo.MutationFunction<Types.SetStoreProductOutOfStockMutation, Types.SetStoreProductOutOfStockMutationVariables>;

/**
 * __useSetStoreProductOutOfStockMutation__
 *
 * To run a mutation, you first call `useSetStoreProductOutOfStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStoreProductOutOfStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStoreProductOutOfStockMutation, { data, loading, error }] = useSetStoreProductOutOfStockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      outOfStock: // value for 'outOfStock'
 *      storeIds: // value for 'storeIds'
 *   },
 * });
 */
export function useSetStoreProductOutOfStockMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetStoreProductOutOfStockMutation, Types.SetStoreProductOutOfStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetStoreProductOutOfStockMutation, Types.SetStoreProductOutOfStockMutationVariables>(SetStoreProductOutOfStockDocument, options);
      }
export type SetStoreProductOutOfStockMutationHookResult = ReturnType<typeof useSetStoreProductOutOfStockMutation>;
export type SetStoreProductOutOfStockMutationResult = Apollo.MutationResult<Types.SetStoreProductOutOfStockMutation>;
export type SetStoreProductOutOfStockMutationOptions = Apollo.BaseMutationOptions<Types.SetStoreProductOutOfStockMutation, Types.SetStoreProductOutOfStockMutationVariables>;
export const ActivateProductsForStoreDocument = gql`
    mutation activateProductsForStore($ids: [Int!]!, $storeId: Int!) {
  activateProductsForStore(ids: $ids, storeId: $storeId)
}
    `;
export type ActivateProductsForStoreMutationFn = Apollo.MutationFunction<Types.ActivateProductsForStoreMutation, Types.ActivateProductsForStoreMutationVariables>;

/**
 * __useActivateProductsForStoreMutation__
 *
 * To run a mutation, you first call `useActivateProductsForStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateProductsForStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateProductsForStoreMutation, { data, loading, error }] = useActivateProductsForStoreMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useActivateProductsForStoreMutation(baseOptions?: Apollo.MutationHookOptions<Types.ActivateProductsForStoreMutation, Types.ActivateProductsForStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ActivateProductsForStoreMutation, Types.ActivateProductsForStoreMutationVariables>(ActivateProductsForStoreDocument, options);
      }
export type ActivateProductsForStoreMutationHookResult = ReturnType<typeof useActivateProductsForStoreMutation>;
export type ActivateProductsForStoreMutationResult = Apollo.MutationResult<Types.ActivateProductsForStoreMutation>;
export type ActivateProductsForStoreMutationOptions = Apollo.BaseMutationOptions<Types.ActivateProductsForStoreMutation, Types.ActivateProductsForStoreMutationVariables>;
export const DeactivateProductsForStoreDocument = gql`
    mutation deactivateProductsForStore($ids: [Int!]!, $storeId: Int!) {
  deactivateProductsForStore(ids: $ids, storeId: $storeId)
}
    `;
export type DeactivateProductsForStoreMutationFn = Apollo.MutationFunction<Types.DeactivateProductsForStoreMutation, Types.DeactivateProductsForStoreMutationVariables>;

/**
 * __useDeactivateProductsForStoreMutation__
 *
 * To run a mutation, you first call `useDeactivateProductsForStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateProductsForStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateProductsForStoreMutation, { data, loading, error }] = useDeactivateProductsForStoreMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useDeactivateProductsForStoreMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeactivateProductsForStoreMutation, Types.DeactivateProductsForStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeactivateProductsForStoreMutation, Types.DeactivateProductsForStoreMutationVariables>(DeactivateProductsForStoreDocument, options);
      }
export type DeactivateProductsForStoreMutationHookResult = ReturnType<typeof useDeactivateProductsForStoreMutation>;
export type DeactivateProductsForStoreMutationResult = Apollo.MutationResult<Types.DeactivateProductsForStoreMutation>;
export type DeactivateProductsForStoreMutationOptions = Apollo.BaseMutationOptions<Types.DeactivateProductsForStoreMutation, Types.DeactivateProductsForStoreMutationVariables>;
export const GetAllMyProductCategoriesDocument = gql`
    query GetAllMyProductCategories {
  getAllProductCategoriesForPartner {
    description
    descriptionAr
    id
    name
    nameAr
    order
  }
}
    `;

/**
 * __useGetAllMyProductCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllMyProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyProductCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMyProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllMyProductCategoriesQuery, Types.GetAllMyProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllMyProductCategoriesQuery, Types.GetAllMyProductCategoriesQueryVariables>(GetAllMyProductCategoriesDocument, options);
      }
export function useGetAllMyProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllMyProductCategoriesQuery, Types.GetAllMyProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllMyProductCategoriesQuery, Types.GetAllMyProductCategoriesQueryVariables>(GetAllMyProductCategoriesDocument, options);
        }
export function useGetAllMyProductCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllMyProductCategoriesQuery, Types.GetAllMyProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllMyProductCategoriesQuery, Types.GetAllMyProductCategoriesQueryVariables>(GetAllMyProductCategoriesDocument, options);
        }
export type GetAllMyProductCategoriesQueryHookResult = ReturnType<typeof useGetAllMyProductCategoriesQuery>;
export type GetAllMyProductCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllMyProductCategoriesLazyQuery>;
export type GetAllMyProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetAllMyProductCategoriesSuspenseQuery>;
export type GetAllMyProductCategoriesQueryResult = Apollo.QueryResult<Types.GetAllMyProductCategoriesQuery, Types.GetAllMyProductCategoriesQueryVariables>;
export const GetProductCategoryDocument = gql`
    query GetProductCategory($id: Int!) {
  getProductCategory(id: $id) {
    description
    descriptionAr
    id
    name
    nameAr
    order
  }
}
    `;

/**
 * __useGetProductCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductCategoryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetProductCategoryQuery, Types.GetProductCategoryQueryVariables> & ({ variables: Types.GetProductCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProductCategoryQuery, Types.GetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
      }
export function useGetProductCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProductCategoryQuery, Types.GetProductCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProductCategoryQuery, Types.GetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
        }
export function useGetProductCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetProductCategoryQuery, Types.GetProductCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetProductCategoryQuery, Types.GetProductCategoryQueryVariables>(GetProductCategoryDocument, options);
        }
export type GetProductCategoryQueryHookResult = ReturnType<typeof useGetProductCategoryQuery>;
export type GetProductCategoryLazyQueryHookResult = ReturnType<typeof useGetProductCategoryLazyQuery>;
export type GetProductCategorySuspenseQueryHookResult = ReturnType<typeof useGetProductCategorySuspenseQuery>;
export type GetProductCategoryQueryResult = Apollo.QueryResult<Types.GetProductCategoryQuery, Types.GetProductCategoryQueryVariables>;
export const CreateProductCategoryDocument = gql`
    mutation CreateProductCategory($description: String, $descriptionAr: String, $name: String!, $nameAr: String!, $order: Int) {
  createProductCategory(
    createProductCategoryDto: {description: $description, descriptionAr: $descriptionAr, name: $name, nameAr: $nameAr, order: $order}
  ) {
    id
  }
}
    `;
export type CreateProductCategoryMutationFn = Apollo.MutationFunction<Types.CreateProductCategoryMutation, Types.CreateProductCategoryMutationVariables>;

/**
 * __useCreateProductCategoryMutation__
 *
 * To run a mutation, you first call `useCreateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductCategoryMutation, { data, loading, error }] = useCreateProductCategoryMutation({
 *   variables: {
 *      description: // value for 'description'
 *      descriptionAr: // value for 'descriptionAr'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCreateProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductCategoryMutation, Types.CreateProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductCategoryMutation, Types.CreateProductCategoryMutationVariables>(CreateProductCategoryDocument, options);
      }
export type CreateProductCategoryMutationHookResult = ReturnType<typeof useCreateProductCategoryMutation>;
export type CreateProductCategoryMutationResult = Apollo.MutationResult<Types.CreateProductCategoryMutation>;
export type CreateProductCategoryMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductCategoryMutation, Types.CreateProductCategoryMutationVariables>;
export const UpdateProductCategoryDocument = gql`
    mutation UpdateProductCategory($id: Int!, $description: String, $descriptionAr: String, $name: String!, $nameAr: String!, $order: Int) {
  updateProductCategory(
    id: $id
    updateProductCategoryDto: {description: $description, descriptionAr: $descriptionAr, name: $name, nameAr: $nameAr, order: $order}
  ) {
    id
  }
}
    `;
export type UpdateProductCategoryMutationFn = Apollo.MutationFunction<Types.UpdateProductCategoryMutation, Types.UpdateProductCategoryMutationVariables>;

/**
 * __useUpdateProductCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductCategoryMutation, { data, loading, error }] = useUpdateProductCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      descriptionAr: // value for 'descriptionAr'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUpdateProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductCategoryMutation, Types.UpdateProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductCategoryMutation, Types.UpdateProductCategoryMutationVariables>(UpdateProductCategoryDocument, options);
      }
export type UpdateProductCategoryMutationHookResult = ReturnType<typeof useUpdateProductCategoryMutation>;
export type UpdateProductCategoryMutationResult = Apollo.MutationResult<Types.UpdateProductCategoryMutation>;
export type UpdateProductCategoryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductCategoryMutation, Types.UpdateProductCategoryMutationVariables>;
export const DeleteProductCategoryDocument = gql`
    mutation deleteProductCategory($id: Int!) {
  deleteProductCategory(id: $id)
}
    `;
export type DeleteProductCategoryMutationFn = Apollo.MutationFunction<Types.DeleteProductCategoryMutation, Types.DeleteProductCategoryMutationVariables>;

/**
 * __useDeleteProductCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductCategoryMutation, { data, loading, error }] = useDeleteProductCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductCategoryMutation, Types.DeleteProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductCategoryMutation, Types.DeleteProductCategoryMutationVariables>(DeleteProductCategoryDocument, options);
      }
export type DeleteProductCategoryMutationHookResult = ReturnType<typeof useDeleteProductCategoryMutation>;
export type DeleteProductCategoryMutationResult = Apollo.MutationResult<Types.DeleteProductCategoryMutation>;
export type DeleteProductCategoryMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductCategoryMutation, Types.DeleteProductCategoryMutationVariables>;
export const GetAllMyProductOptionCategoriesDocument = gql`
    query GetAllMyProductOptionCategories {
  getAllProductOptionCategoriesForPartner {
    description
    descriptionAr
    id
    name
    nameAr
    min
    max
    productOptions {
      description
      descriptionAr
      id
      name
      nameAr
      price
    }
  }
}
    `;

/**
 * __useGetAllMyProductOptionCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllMyProductOptionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyProductOptionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyProductOptionCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMyProductOptionCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllMyProductOptionCategoriesQuery, Types.GetAllMyProductOptionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllMyProductOptionCategoriesQuery, Types.GetAllMyProductOptionCategoriesQueryVariables>(GetAllMyProductOptionCategoriesDocument, options);
      }
export function useGetAllMyProductOptionCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllMyProductOptionCategoriesQuery, Types.GetAllMyProductOptionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllMyProductOptionCategoriesQuery, Types.GetAllMyProductOptionCategoriesQueryVariables>(GetAllMyProductOptionCategoriesDocument, options);
        }
export function useGetAllMyProductOptionCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllMyProductOptionCategoriesQuery, Types.GetAllMyProductOptionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllMyProductOptionCategoriesQuery, Types.GetAllMyProductOptionCategoriesQueryVariables>(GetAllMyProductOptionCategoriesDocument, options);
        }
export type GetAllMyProductOptionCategoriesQueryHookResult = ReturnType<typeof useGetAllMyProductOptionCategoriesQuery>;
export type GetAllMyProductOptionCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllMyProductOptionCategoriesLazyQuery>;
export type GetAllMyProductOptionCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetAllMyProductOptionCategoriesSuspenseQuery>;
export type GetAllMyProductOptionCategoriesQueryResult = Apollo.QueryResult<Types.GetAllMyProductOptionCategoriesQuery, Types.GetAllMyProductOptionCategoriesQueryVariables>;
export const GetProductOptionCategoryDocument = gql`
    query GetProductOptionCategory($id: Int!) {
  getProductOptionCategory(id: $id) {
    description
    descriptionAr
    id
    name
    nameAr
    min
    max
    productOptions {
      description
      descriptionAr
      id
      name
      nameAr
      price
    }
  }
}
    `;

/**
 * __useGetProductOptionCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductOptionCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductOptionCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductOptionCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductOptionCategoryQuery(baseOptions: Apollo.QueryHookOptions<Types.GetProductOptionCategoryQuery, Types.GetProductOptionCategoryQueryVariables> & ({ variables: Types.GetProductOptionCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProductOptionCategoryQuery, Types.GetProductOptionCategoryQueryVariables>(GetProductOptionCategoryDocument, options);
      }
export function useGetProductOptionCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProductOptionCategoryQuery, Types.GetProductOptionCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProductOptionCategoryQuery, Types.GetProductOptionCategoryQueryVariables>(GetProductOptionCategoryDocument, options);
        }
export function useGetProductOptionCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetProductOptionCategoryQuery, Types.GetProductOptionCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetProductOptionCategoryQuery, Types.GetProductOptionCategoryQueryVariables>(GetProductOptionCategoryDocument, options);
        }
export type GetProductOptionCategoryQueryHookResult = ReturnType<typeof useGetProductOptionCategoryQuery>;
export type GetProductOptionCategoryLazyQueryHookResult = ReturnType<typeof useGetProductOptionCategoryLazyQuery>;
export type GetProductOptionCategorySuspenseQueryHookResult = ReturnType<typeof useGetProductOptionCategorySuspenseQuery>;
export type GetProductOptionCategoryQueryResult = Apollo.QueryResult<Types.GetProductOptionCategoryQuery, Types.GetProductOptionCategoryQueryVariables>;
export const CreateProductOptionCategoryDocument = gql`
    mutation CreateProductOptionCategory($description: String, $descriptionAr: String, $name: String!, $nameAr: String!, $min: Int!, $max: Int!, $productOptions: [ProductOptionDto!]!) {
  createProductOptionCategory(
    createProductOptionCategoryDto: {description: $description, descriptionAr: $descriptionAr, name: $name, nameAr: $nameAr, min: $min, max: $max, productOptions: $productOptions}
  ) {
    id
  }
}
    `;
export type CreateProductOptionCategoryMutationFn = Apollo.MutationFunction<Types.CreateProductOptionCategoryMutation, Types.CreateProductOptionCategoryMutationVariables>;

/**
 * __useCreateProductOptionCategoryMutation__
 *
 * To run a mutation, you first call `useCreateProductOptionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductOptionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductOptionCategoryMutation, { data, loading, error }] = useCreateProductOptionCategoryMutation({
 *   variables: {
 *      description: // value for 'description'
 *      descriptionAr: // value for 'descriptionAr'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      productOptions: // value for 'productOptions'
 *   },
 * });
 */
export function useCreateProductOptionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateProductOptionCategoryMutation, Types.CreateProductOptionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateProductOptionCategoryMutation, Types.CreateProductOptionCategoryMutationVariables>(CreateProductOptionCategoryDocument, options);
      }
export type CreateProductOptionCategoryMutationHookResult = ReturnType<typeof useCreateProductOptionCategoryMutation>;
export type CreateProductOptionCategoryMutationResult = Apollo.MutationResult<Types.CreateProductOptionCategoryMutation>;
export type CreateProductOptionCategoryMutationOptions = Apollo.BaseMutationOptions<Types.CreateProductOptionCategoryMutation, Types.CreateProductOptionCategoryMutationVariables>;
export const UpdateProductOptionCategoryDocument = gql`
    mutation UpdateProductOptionCategory($id: Int!, $description: String, $descriptionAr: String, $name: String!, $nameAr: String!, $min: Int!, $max: Int!, $productOptions: [ProductOptionDto!]!) {
  updateProductOptionCategory(
    id: $id
    updateProductOptionCategoryDto: {description: $description, descriptionAr: $descriptionAr, name: $name, nameAr: $nameAr, min: $min, max: $max, productOptions: $productOptions}
  ) {
    id
  }
}
    `;
export type UpdateProductOptionCategoryMutationFn = Apollo.MutationFunction<Types.UpdateProductOptionCategoryMutation, Types.UpdateProductOptionCategoryMutationVariables>;

/**
 * __useUpdateProductOptionCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateProductOptionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductOptionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductOptionCategoryMutation, { data, loading, error }] = useUpdateProductOptionCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      descriptionAr: // value for 'descriptionAr'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      productOptions: // value for 'productOptions'
 *   },
 * });
 */
export function useUpdateProductOptionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateProductOptionCategoryMutation, Types.UpdateProductOptionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateProductOptionCategoryMutation, Types.UpdateProductOptionCategoryMutationVariables>(UpdateProductOptionCategoryDocument, options);
      }
export type UpdateProductOptionCategoryMutationHookResult = ReturnType<typeof useUpdateProductOptionCategoryMutation>;
export type UpdateProductOptionCategoryMutationResult = Apollo.MutationResult<Types.UpdateProductOptionCategoryMutation>;
export type UpdateProductOptionCategoryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateProductOptionCategoryMutation, Types.UpdateProductOptionCategoryMutationVariables>;
export const DeleteProductOptionCategoryDocument = gql`
    mutation deleteProductOptionCategory($id: Int!) {
  deleteProductOptionCategory(id: $id)
}
    `;
export type DeleteProductOptionCategoryMutationFn = Apollo.MutationFunction<Types.DeleteProductOptionCategoryMutation, Types.DeleteProductOptionCategoryMutationVariables>;

/**
 * __useDeleteProductOptionCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteProductOptionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductOptionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductOptionCategoryMutation, { data, loading, error }] = useDeleteProductOptionCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductOptionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteProductOptionCategoryMutation, Types.DeleteProductOptionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteProductOptionCategoryMutation, Types.DeleteProductOptionCategoryMutationVariables>(DeleteProductOptionCategoryDocument, options);
      }
export type DeleteProductOptionCategoryMutationHookResult = ReturnType<typeof useDeleteProductOptionCategoryMutation>;
export type DeleteProductOptionCategoryMutationResult = Apollo.MutationResult<Types.DeleteProductOptionCategoryMutation>;
export type DeleteProductOptionCategoryMutationOptions = Apollo.BaseMutationOptions<Types.DeleteProductOptionCategoryMutation, Types.DeleteProductOptionCategoryMutationVariables>;
export const GetOrderStatisticsDocument = gql`
    query GetOrderStatistics($input: GetOrderStatisticsInput!) {
  getOrderStatistics(input: $input) {
    averageOrderValue
    cancellationRate
    cancelledOrders
    totalDeliveryFees
    totalDiscounts
    totalOrders
    totalRevenue
    totalSubtotal
    totalTips
    dailyTrend {
      date
      orderCount
      totalRevenue
    }
    statusBreakdown {
      count
      percentage
      status
    }
    topStores {
      averageOrderValue
      orderCount
      storeId
      storeName
      storeNameAr
      totalRevenue
    }
  }
}
    `;

/**
 * __useGetOrderStatisticsQuery__
 *
 * To run a query within a React component, call `useGetOrderStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatisticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrderStatisticsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOrderStatisticsQuery, Types.GetOrderStatisticsQueryVariables> & ({ variables: Types.GetOrderStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOrderStatisticsQuery, Types.GetOrderStatisticsQueryVariables>(GetOrderStatisticsDocument, options);
      }
export function useGetOrderStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOrderStatisticsQuery, Types.GetOrderStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOrderStatisticsQuery, Types.GetOrderStatisticsQueryVariables>(GetOrderStatisticsDocument, options);
        }
export function useGetOrderStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetOrderStatisticsQuery, Types.GetOrderStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetOrderStatisticsQuery, Types.GetOrderStatisticsQueryVariables>(GetOrderStatisticsDocument, options);
        }
export type GetOrderStatisticsQueryHookResult = ReturnType<typeof useGetOrderStatisticsQuery>;
export type GetOrderStatisticsLazyQueryHookResult = ReturnType<typeof useGetOrderStatisticsLazyQuery>;
export type GetOrderStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetOrderStatisticsSuspenseQuery>;
export type GetOrderStatisticsQueryResult = Apollo.QueryResult<Types.GetOrderStatisticsQuery, Types.GetOrderStatisticsQueryVariables>;
export const GetAllMyStoresDocument = gql`
    query GetAllMyStores {
  getAllStoresForPartner {
    address
    createdAt
    id
    name
    nameAr
    phone
    updatedAt
    longitude
    latitude
    regionId
    cityId
    isActive
    isOnline
    isTemporarilyClosed
    temporarilyClosedNote
    temporarilyClosedNoteAr
    preparationTime
    locationImage {
      id
      url
    }
    defaultWorkingHours {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAllMyStoresQuery__
 *
 * To run a query within a React component, call `useGetAllMyStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyStoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMyStoresQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllMyStoresQuery, Types.GetAllMyStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllMyStoresQuery, Types.GetAllMyStoresQueryVariables>(GetAllMyStoresDocument, options);
      }
export function useGetAllMyStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllMyStoresQuery, Types.GetAllMyStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllMyStoresQuery, Types.GetAllMyStoresQueryVariables>(GetAllMyStoresDocument, options);
        }
export function useGetAllMyStoresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllMyStoresQuery, Types.GetAllMyStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllMyStoresQuery, Types.GetAllMyStoresQueryVariables>(GetAllMyStoresDocument, options);
        }
export type GetAllMyStoresQueryHookResult = ReturnType<typeof useGetAllMyStoresQuery>;
export type GetAllMyStoresLazyQueryHookResult = ReturnType<typeof useGetAllMyStoresLazyQuery>;
export type GetAllMyStoresSuspenseQueryHookResult = ReturnType<typeof useGetAllMyStoresSuspenseQuery>;
export type GetAllMyStoresQueryResult = Apollo.QueryResult<Types.GetAllMyStoresQuery, Types.GetAllMyStoresQueryVariables>;
export const GetStoreDocument = gql`
    query getStore($id: Int!) {
  getStore(id: $id) {
    address
    createdAt
    id
    name
    nameAr
    phone
    updatedAt
    longitude
    latitude
    regionId
    cityId
    isActive
    isOnline
    isTemporarilyClosed
    temporarilyClosedNote
    temporarilyClosedNoteAr
    preparationTime
    locationImage {
      id
      url
    }
    defaultWorkingHours {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStoreQuery__
 *
 * To run a query within a React component, call `useGetStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStoreQuery(baseOptions: Apollo.QueryHookOptions<Types.GetStoreQuery, Types.GetStoreQueryVariables> & ({ variables: Types.GetStoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetStoreQuery, Types.GetStoreQueryVariables>(GetStoreDocument, options);
      }
export function useGetStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetStoreQuery, Types.GetStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetStoreQuery, Types.GetStoreQueryVariables>(GetStoreDocument, options);
        }
export function useGetStoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetStoreQuery, Types.GetStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetStoreQuery, Types.GetStoreQueryVariables>(GetStoreDocument, options);
        }
export type GetStoreQueryHookResult = ReturnType<typeof useGetStoreQuery>;
export type GetStoreLazyQueryHookResult = ReturnType<typeof useGetStoreLazyQuery>;
export type GetStoreSuspenseQueryHookResult = ReturnType<typeof useGetStoreSuspenseQuery>;
export type GetStoreQueryResult = Apollo.QueryResult<Types.GetStoreQuery, Types.GetStoreQueryVariables>;
export const CreateStoreDocument = gql`
    mutation createStore($address: String!, $name: String!, $nameAr: String!, $phone: String!, $longitude: Float!, $latitude: Float!, $regionId: String!, $cityId: String!, $defaultWorkingHoursId: Int, $preparationTime: Int, $locationImageId: Int) {
  createStore(
    createStoreDto: {address: $address, name: $name, nameAr: $nameAr, phone: $phone, longitude: $longitude, latitude: $latitude, regionId: $regionId, cityId: $cityId, defaultWorkingHoursId: $defaultWorkingHoursId, preparationTime: $preparationTime, locationImageId: $locationImageId}
  ) {
    id
  }
}
    `;
export type CreateStoreMutationFn = Apollo.MutationFunction<Types.CreateStoreMutation, Types.CreateStoreMutationVariables>;

/**
 * __useCreateStoreMutation__
 *
 * To run a mutation, you first call `useCreateStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoreMutation, { data, loading, error }] = useCreateStoreMutation({
 *   variables: {
 *      address: // value for 'address'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      phone: // value for 'phone'
 *      longitude: // value for 'longitude'
 *      latitude: // value for 'latitude'
 *      regionId: // value for 'regionId'
 *      cityId: // value for 'cityId'
 *      defaultWorkingHoursId: // value for 'defaultWorkingHoursId'
 *      preparationTime: // value for 'preparationTime'
 *   },
 * });
 */
export function useCreateStoreMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateStoreMutation, Types.CreateStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateStoreMutation, Types.CreateStoreMutationVariables>(CreateStoreDocument, options);
      }
export type CreateStoreMutationHookResult = ReturnType<typeof useCreateStoreMutation>;
export type CreateStoreMutationResult = Apollo.MutationResult<Types.CreateStoreMutation>;
export type CreateStoreMutationOptions = Apollo.BaseMutationOptions<Types.CreateStoreMutation, Types.CreateStoreMutationVariables>;
export const UpdateStoreDocument = gql`
    mutation updateStore($id: Int!, $address: String!, $name: String!, $nameAr: String!, $phone: String!, $longitude: Float!, $latitude: Float!, $regionId: String!, $cityId: String!, $defaultWorkingHoursId: Int, $preparationTime: Int, $locationImageId: Int) {
  updateStore(
    id: $id
    updateStoreDto: {address: $address, name: $name, nameAr: $nameAr, phone: $phone, longitude: $longitude, latitude: $latitude, regionId: $regionId, cityId: $cityId, defaultWorkingHoursId: $defaultWorkingHoursId, preparationTime: $preparationTime, locationImageId: $locationImageId}
  )
}
    `;
export type UpdateStoreMutationFn = Apollo.MutationFunction<Types.UpdateStoreMutation, Types.UpdateStoreMutationVariables>;

/**
 * __useUpdateStoreMutation__
 *
 * To run a mutation, you first call `useUpdateStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoreMutation, { data, loading, error }] = useUpdateStoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      phone: // value for 'phone'
 *      longitude: // value for 'longitude'
 *      latitude: // value for 'latitude'
 *      regionId: // value for 'regionId'
 *      cityId: // value for 'cityId'
 *      defaultWorkingHoursId: // value for 'defaultWorkingHoursId'
 *      preparationTime: // value for 'preparationTime'
 *   },
 * });
 */
export function useUpdateStoreMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateStoreMutation, Types.UpdateStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateStoreMutation, Types.UpdateStoreMutationVariables>(UpdateStoreDocument, options);
      }
export type UpdateStoreMutationHookResult = ReturnType<typeof useUpdateStoreMutation>;
export type UpdateStoreMutationResult = Apollo.MutationResult<Types.UpdateStoreMutation>;
export type UpdateStoreMutationOptions = Apollo.BaseMutationOptions<Types.UpdateStoreMutation, Types.UpdateStoreMutationVariables>;
export const DeleteStoreDocument = gql`
    mutation deleteStore($id: Int!) {
  deleteStore(id: $id)
}
    `;
export type DeleteStoreMutationFn = Apollo.MutationFunction<Types.DeleteStoreMutation, Types.DeleteStoreMutationVariables>;

/**
 * __useDeleteStoreMutation__
 *
 * To run a mutation, you first call `useDeleteStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStoreMutation, { data, loading, error }] = useDeleteStoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStoreMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteStoreMutation, Types.DeleteStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteStoreMutation, Types.DeleteStoreMutationVariables>(DeleteStoreDocument, options);
      }
export type DeleteStoreMutationHookResult = ReturnType<typeof useDeleteStoreMutation>;
export type DeleteStoreMutationResult = Apollo.MutationResult<Types.DeleteStoreMutation>;
export type DeleteStoreMutationOptions = Apollo.BaseMutationOptions<Types.DeleteStoreMutation, Types.DeleteStoreMutationVariables>;
export const ActivateStoresDocument = gql`
    mutation activateStores($ids: [Int!]!) {
  activateStores(ids: $ids)
}
    `;
export type ActivateStoresMutationFn = Apollo.MutationFunction<Types.ActivateStoresMutation, Types.ActivateStoresMutationVariables>;

/**
 * __useActivateStoresMutation__
 *
 * To run a mutation, you first call `useActivateStoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateStoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateStoresMutation, { data, loading, error }] = useActivateStoresMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useActivateStoresMutation(baseOptions?: Apollo.MutationHookOptions<Types.ActivateStoresMutation, Types.ActivateStoresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ActivateStoresMutation, Types.ActivateStoresMutationVariables>(ActivateStoresDocument, options);
      }
export type ActivateStoresMutationHookResult = ReturnType<typeof useActivateStoresMutation>;
export type ActivateStoresMutationResult = Apollo.MutationResult<Types.ActivateStoresMutation>;
export type ActivateStoresMutationOptions = Apollo.BaseMutationOptions<Types.ActivateStoresMutation, Types.ActivateStoresMutationVariables>;
export const DeactivateStoresDocument = gql`
    mutation deactivateStores($ids: [Int!]!) {
  deactivateStores(ids: $ids)
}
    `;
export type DeactivateStoresMutationFn = Apollo.MutationFunction<Types.DeactivateStoresMutation, Types.DeactivateStoresMutationVariables>;

/**
 * __useDeactivateStoresMutation__
 *
 * To run a mutation, you first call `useDeactivateStoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateStoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateStoresMutation, { data, loading, error }] = useDeactivateStoresMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeactivateStoresMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeactivateStoresMutation, Types.DeactivateStoresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeactivateStoresMutation, Types.DeactivateStoresMutationVariables>(DeactivateStoresDocument, options);
      }
export type DeactivateStoresMutationHookResult = ReturnType<typeof useDeactivateStoresMutation>;
export type DeactivateStoresMutationResult = Apollo.MutationResult<Types.DeactivateStoresMutation>;
export type DeactivateStoresMutationOptions = Apollo.BaseMutationOptions<Types.DeactivateStoresMutation, Types.DeactivateStoresMutationVariables>;
export const SetStoreTemporaryClosureDocument = gql`
    mutation setStoreTemporaryClosure($id: Int!, $isTemporarilyClosed: Boolean!, $temporarilyClosedNote: String, $temporarilyClosedNoteAr: String) {
  setStoreTemporaryClosure(
    id: $id
    input: {isTemporarilyClosed: $isTemporarilyClosed, temporarilyClosedNote: $temporarilyClosedNote, temporarilyClosedNoteAr: $temporarilyClosedNoteAr}
  ) {
    id
    isTemporarilyClosed
    temporarilyClosedNote
    temporarilyClosedNoteAr
  }
}
    `;
export type SetStoreTemporaryClosureMutationFn = Apollo.MutationFunction<Types.SetStoreTemporaryClosureMutation, Types.SetStoreTemporaryClosureMutationVariables>;

/**
 * __useSetStoreTemporaryClosureMutation__
 *
 * To run a mutation, you first call `useSetStoreTemporaryClosureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStoreTemporaryClosureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStoreTemporaryClosureMutation, { data, loading, error }] = useSetStoreTemporaryClosureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isTemporarilyClosed: // value for 'isTemporarilyClosed'
 *      temporarilyClosedNote: // value for 'temporarilyClosedNote'
 *      temporarilyClosedNoteAr: // value for 'temporarilyClosedNoteAr'
 *   },
 * });
 */
export function useSetStoreTemporaryClosureMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetStoreTemporaryClosureMutation, Types.SetStoreTemporaryClosureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetStoreTemporaryClosureMutation, Types.SetStoreTemporaryClosureMutationVariables>(SetStoreTemporaryClosureDocument, options);
      }
export type SetStoreTemporaryClosureMutationHookResult = ReturnType<typeof useSetStoreTemporaryClosureMutation>;
export type SetStoreTemporaryClosureMutationResult = Apollo.MutationResult<Types.SetStoreTemporaryClosureMutation>;
export type SetStoreTemporaryClosureMutationOptions = Apollo.BaseMutationOptions<Types.SetStoreTemporaryClosureMutation, Types.SetStoreTemporaryClosureMutationVariables>;
export const StoreCreatedDocument = gql`
    subscription StoreCreated {
  storeCreated {
    id
    name
    nameAr
    phone
    address
    longitude
    latitude
    isActive
    isOnline
  }
}
    `;

/**
 * __useStoreCreatedSubscription__
 *
 * To run a query within a React component, call `useStoreCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStoreCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useStoreCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<Types.StoreCreatedSubscription, Types.StoreCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.StoreCreatedSubscription, Types.StoreCreatedSubscriptionVariables>(StoreCreatedDocument, options);
      }
export type StoreCreatedSubscriptionHookResult = ReturnType<typeof useStoreCreatedSubscription>;
export type StoreCreatedSubscriptionResult = Apollo.SubscriptionResult<Types.StoreCreatedSubscription>;
export const StoreUpdatedDocument = gql`
    subscription StoreUpdated {
  storeUpdated {
    id
    name
    nameAr
    phone
    address
    longitude
    latitude
    isActive
    isOnline
  }
}
    `;

/**
 * __useStoreUpdatedSubscription__
 *
 * To run a query within a React component, call `useStoreUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStoreUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useStoreUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<Types.StoreUpdatedSubscription, Types.StoreUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<Types.StoreUpdatedSubscription, Types.StoreUpdatedSubscriptionVariables>(StoreUpdatedDocument, options);
      }
export type StoreUpdatedSubscriptionHookResult = ReturnType<typeof useStoreUpdatedSubscription>;
export type StoreUpdatedSubscriptionResult = Apollo.SubscriptionResult<Types.StoreUpdatedSubscription>;
export const GetMyUserDocument = gql`
    query GetMyUser {
  getMyUser {
    email
    id
    name
  }
}
    `;

/**
 * __useGetMyUserQuery__
 *
 * To run a query within a React component, call `useGetMyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>(GetMyUserDocument, options);
      }
export function useGetMyUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>(GetMyUserDocument, options);
        }
export function useGetMyUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>(GetMyUserDocument, options);
        }
export type GetMyUserQueryHookResult = ReturnType<typeof useGetMyUserQuery>;
export type GetMyUserLazyQueryHookResult = ReturnType<typeof useGetMyUserLazyQuery>;
export type GetMyUserSuspenseQueryHookResult = ReturnType<typeof useGetMyUserSuspenseQuery>;
export type GetMyUserQueryResult = Apollo.QueryResult<Types.GetMyUserQuery, Types.GetMyUserQueryVariables>;
export const GetAllMyUsersDocument = gql`
    query GetAllMyUsers {
  getAllUsersForPartner {
    email
    id
    name
    storeName
  }
}
    `;

/**
 * __useGetAllMyUsersQuery__
 *
 * To run a query within a React component, call `useGetAllMyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMyUsersQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllMyUsersQuery, Types.GetAllMyUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllMyUsersQuery, Types.GetAllMyUsersQueryVariables>(GetAllMyUsersDocument, options);
      }
export function useGetAllMyUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllMyUsersQuery, Types.GetAllMyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllMyUsersQuery, Types.GetAllMyUsersQueryVariables>(GetAllMyUsersDocument, options);
        }
export function useGetAllMyUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllMyUsersQuery, Types.GetAllMyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllMyUsersQuery, Types.GetAllMyUsersQueryVariables>(GetAllMyUsersDocument, options);
        }
export type GetAllMyUsersQueryHookResult = ReturnType<typeof useGetAllMyUsersQuery>;
export type GetAllMyUsersLazyQueryHookResult = ReturnType<typeof useGetAllMyUsersLazyQuery>;
export type GetAllMyUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllMyUsersSuspenseQuery>;
export type GetAllMyUsersQueryResult = Apollo.QueryResult<Types.GetAllMyUsersQuery, Types.GetAllMyUsersQueryVariables>;
export const UpdateMyPasswordDocument = gql`
    mutation UpdateMyPassword($newPassword: String!, $oldPassword: String!) {
  updateMyPassword(newPassword: $newPassword, oldPassword: $oldPassword) {
    id
  }
}
    `;
export type UpdateMyPasswordMutationFn = Apollo.MutationFunction<Types.UpdateMyPasswordMutation, Types.UpdateMyPasswordMutationVariables>;

/**
 * __useUpdateMyPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyPasswordMutation, { data, loading, error }] = useUpdateMyPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */
export function useUpdateMyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMyPasswordMutation, Types.UpdateMyPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMyPasswordMutation, Types.UpdateMyPasswordMutationVariables>(UpdateMyPasswordDocument, options);
      }
export type UpdateMyPasswordMutationHookResult = ReturnType<typeof useUpdateMyPasswordMutation>;
export type UpdateMyPasswordMutationResult = Apollo.MutationResult<Types.UpdateMyPasswordMutation>;
export type UpdateMyPasswordMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMyPasswordMutation, Types.UpdateMyPasswordMutationVariables>;
export const UpdateMyUserDocument = gql`
    mutation UpdateMyUser($email: String, $name: String) {
  updateMyUser(updateUserDto: {email: $email, name: $name}) {
    id
  }
}
    `;
export type UpdateMyUserMutationFn = Apollo.MutationFunction<Types.UpdateMyUserMutation, Types.UpdateMyUserMutationVariables>;

/**
 * __useUpdateMyUserMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMutation, { data, loading, error }] = useUpdateMyUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateMyUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMyUserMutation, Types.UpdateMyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMyUserMutation, Types.UpdateMyUserMutationVariables>(UpdateMyUserDocument, options);
      }
export type UpdateMyUserMutationHookResult = ReturnType<typeof useUpdateMyUserMutation>;
export type UpdateMyUserMutationResult = Apollo.MutationResult<Types.UpdateMyUserMutation>;
export type UpdateMyUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMyUserMutation, Types.UpdateMyUserMutationVariables>;
export const RemoveUserForPartnerDocument = gql`
    mutation RemoveUserForPartner($id: Int!) {
  removeUserForPartner(id: $id) {
    id
  }
}
    `;
export type RemoveUserForPartnerMutationFn = Apollo.MutationFunction<Types.RemoveUserForPartnerMutation, Types.RemoveUserForPartnerMutationVariables>;

/**
 * __useRemoveUserForPartnerMutation__
 *
 * To run a mutation, you first call `useRemoveUserForPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserForPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserForPartnerMutation, { data, loading, error }] = useRemoveUserForPartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserForPartnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveUserForPartnerMutation, Types.RemoveUserForPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveUserForPartnerMutation, Types.RemoveUserForPartnerMutationVariables>(RemoveUserForPartnerDocument, options);
      }
export type RemoveUserForPartnerMutationHookResult = ReturnType<typeof useRemoveUserForPartnerMutation>;
export type RemoveUserForPartnerMutationResult = Apollo.MutationResult<Types.RemoveUserForPartnerMutation>;
export type RemoveUserForPartnerMutationOptions = Apollo.BaseMutationOptions<Types.RemoveUserForPartnerMutation, Types.RemoveUserForPartnerMutationVariables>;
export const GetAllMyWorkingHoursDocument = gql`
    query GetAllMyWorkingHours {
  getAllWorkingHoursForPartner {
    id
    name
    nameAr
    startDate
    endDate
    priority
    stores {
      id
      name
    }
    items {
      id
      weekday
      startTime
      endTime
    }
  }
}
    `;

/**
 * __useGetAllMyWorkingHoursQuery__
 *
 * To run a query within a React component, call `useGetAllMyWorkingHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyWorkingHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyWorkingHoursQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMyWorkingHoursQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllMyWorkingHoursQuery, Types.GetAllMyWorkingHoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllMyWorkingHoursQuery, Types.GetAllMyWorkingHoursQueryVariables>(GetAllMyWorkingHoursDocument, options);
      }
export function useGetAllMyWorkingHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllMyWorkingHoursQuery, Types.GetAllMyWorkingHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllMyWorkingHoursQuery, Types.GetAllMyWorkingHoursQueryVariables>(GetAllMyWorkingHoursDocument, options);
        }
export function useGetAllMyWorkingHoursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllMyWorkingHoursQuery, Types.GetAllMyWorkingHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllMyWorkingHoursQuery, Types.GetAllMyWorkingHoursQueryVariables>(GetAllMyWorkingHoursDocument, options);
        }
export type GetAllMyWorkingHoursQueryHookResult = ReturnType<typeof useGetAllMyWorkingHoursQuery>;
export type GetAllMyWorkingHoursLazyQueryHookResult = ReturnType<typeof useGetAllMyWorkingHoursLazyQuery>;
export type GetAllMyWorkingHoursSuspenseQueryHookResult = ReturnType<typeof useGetAllMyWorkingHoursSuspenseQuery>;
export type GetAllMyWorkingHoursQueryResult = Apollo.QueryResult<Types.GetAllMyWorkingHoursQuery, Types.GetAllMyWorkingHoursQueryVariables>;
export const GetWorkingHoursDocument = gql`
    query getWorkingHours($id: Int!) {
  getWorkingHours(id: $id) {
    id
    name
    nameAr
    startDate
    endDate
    priority
    stores {
      id
      name
    }
    items {
      id
      weekday
      startTime
      endTime
    }
  }
}
    `;

/**
 * __useGetWorkingHoursQuery__
 *
 * To run a query within a React component, call `useGetWorkingHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkingHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkingHoursQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkingHoursQuery(baseOptions: Apollo.QueryHookOptions<Types.GetWorkingHoursQuery, Types.GetWorkingHoursQueryVariables> & ({ variables: Types.GetWorkingHoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetWorkingHoursQuery, Types.GetWorkingHoursQueryVariables>(GetWorkingHoursDocument, options);
      }
export function useGetWorkingHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetWorkingHoursQuery, Types.GetWorkingHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetWorkingHoursQuery, Types.GetWorkingHoursQueryVariables>(GetWorkingHoursDocument, options);
        }
export function useGetWorkingHoursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetWorkingHoursQuery, Types.GetWorkingHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetWorkingHoursQuery, Types.GetWorkingHoursQueryVariables>(GetWorkingHoursDocument, options);
        }
export type GetWorkingHoursQueryHookResult = ReturnType<typeof useGetWorkingHoursQuery>;
export type GetWorkingHoursLazyQueryHookResult = ReturnType<typeof useGetWorkingHoursLazyQuery>;
export type GetWorkingHoursSuspenseQueryHookResult = ReturnType<typeof useGetWorkingHoursSuspenseQuery>;
export type GetWorkingHoursQueryResult = Apollo.QueryResult<Types.GetWorkingHoursQuery, Types.GetWorkingHoursQueryVariables>;
export const CreateWorkingHoursDocument = gql`
    mutation createWorkingHours($name: String!, $nameAr: String!, $startDate: String, $endDate: String, $priority: Int, $storeIds: [Int!], $items: [CreateWorkingHoursItemDto!]!) {
  createWorkingHours(
    createWorkingHoursDto: {name: $name, nameAr: $nameAr, startDate: $startDate, endDate: $endDate, priority: $priority, storeIds: $storeIds, items: $items}
  ) {
    id
  }
}
    `;
export type CreateWorkingHoursMutationFn = Apollo.MutationFunction<Types.CreateWorkingHoursMutation, Types.CreateWorkingHoursMutationVariables>;

/**
 * __useCreateWorkingHoursMutation__
 *
 * To run a mutation, you first call `useCreateWorkingHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkingHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkingHoursMutation, { data, loading, error }] = useCreateWorkingHoursMutation({
 *   variables: {
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      priority: // value for 'priority'
 *      storeIds: // value for 'storeIds'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useCreateWorkingHoursMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateWorkingHoursMutation, Types.CreateWorkingHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateWorkingHoursMutation, Types.CreateWorkingHoursMutationVariables>(CreateWorkingHoursDocument, options);
      }
export type CreateWorkingHoursMutationHookResult = ReturnType<typeof useCreateWorkingHoursMutation>;
export type CreateWorkingHoursMutationResult = Apollo.MutationResult<Types.CreateWorkingHoursMutation>;
export type CreateWorkingHoursMutationOptions = Apollo.BaseMutationOptions<Types.CreateWorkingHoursMutation, Types.CreateWorkingHoursMutationVariables>;
export const UpdateWorkingHoursDocument = gql`
    mutation updateWorkingHours($id: Int!, $name: String!, $nameAr: String!, $startDate: String, $endDate: String, $priority: Int, $storeIds: [Int!], $items: [CreateWorkingHoursItemDto!]!) {
  updateWorkingHours(
    id: $id
    updateWorkingHoursDto: {name: $name, nameAr: $nameAr, startDate: $startDate, endDate: $endDate, priority: $priority, storeIds: $storeIds, items: $items}
  ) {
    id
  }
}
    `;
export type UpdateWorkingHoursMutationFn = Apollo.MutationFunction<Types.UpdateWorkingHoursMutation, Types.UpdateWorkingHoursMutationVariables>;

/**
 * __useUpdateWorkingHoursMutation__
 *
 * To run a mutation, you first call `useUpdateWorkingHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkingHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkingHoursMutation, { data, loading, error }] = useUpdateWorkingHoursMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      nameAr: // value for 'nameAr'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      priority: // value for 'priority'
 *      storeIds: // value for 'storeIds'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdateWorkingHoursMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateWorkingHoursMutation, Types.UpdateWorkingHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateWorkingHoursMutation, Types.UpdateWorkingHoursMutationVariables>(UpdateWorkingHoursDocument, options);
      }
export type UpdateWorkingHoursMutationHookResult = ReturnType<typeof useUpdateWorkingHoursMutation>;
export type UpdateWorkingHoursMutationResult = Apollo.MutationResult<Types.UpdateWorkingHoursMutation>;
export type UpdateWorkingHoursMutationOptions = Apollo.BaseMutationOptions<Types.UpdateWorkingHoursMutation, Types.UpdateWorkingHoursMutationVariables>;
export const DeleteWorkingHoursDocument = gql`
    mutation deleteWorkingHours($id: Int!) {
  deleteWorkingHours(id: $id)
}
    `;
export type DeleteWorkingHoursMutationFn = Apollo.MutationFunction<Types.DeleteWorkingHoursMutation, Types.DeleteWorkingHoursMutationVariables>;

/**
 * __useDeleteWorkingHoursMutation__
 *
 * To run a mutation, you first call `useDeleteWorkingHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkingHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkingHoursMutation, { data, loading, error }] = useDeleteWorkingHoursMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkingHoursMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteWorkingHoursMutation, Types.DeleteWorkingHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteWorkingHoursMutation, Types.DeleteWorkingHoursMutationVariables>(DeleteWorkingHoursDocument, options);
      }
export type DeleteWorkingHoursMutationHookResult = ReturnType<typeof useDeleteWorkingHoursMutation>;
export type DeleteWorkingHoursMutationResult = Apollo.MutationResult<Types.DeleteWorkingHoursMutation>;
export type DeleteWorkingHoursMutationOptions = Apollo.BaseMutationOptions<Types.DeleteWorkingHoursMutation, Types.DeleteWorkingHoursMutationVariables>;
